import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names and resolves Tailwind conflicts by last-one-wins.
 *
 * Plain `clsx` only concatenates, so a component's base class can silently beat
 * a caller's override — `w-full` from an input base would swallow a `w-28`
 * passed in by the caller, because the winner is decided by CSS source order,
 * not attribute order. `twMerge` drops the losing class outright, which is what
 * every override site here expects.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
